export const MINUTES_IN_DAY = 24 * 60
